import { AbstractControl, UntypedFormArray, ValidatorFn } from '@angular/forms';

export abstract class FormArrayCheckboxesValidator {
  /**
   * Checks if at least a specified number of checkboxes from FormArray are checked. Otherwise returns "required" validation error.
   * @param minRequired - Minimum number of checkboxes that have to be checked
   * @returns - null if condition is met, otherwise returns "required" error object
   */
  static min(minRequired = 1): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const formArray = control as UntypedFormArray;

      const totalSelected = formArray.controls
        .map((formControl) => formControl.value)
        .reduce((acc, curr) => acc + (curr ? 1 : 0), 0);

      return totalSelected >= minRequired ? null : { required: true };
    };
  }
}
